module.exports = __webpack_public_path__ + "static/media/app-icon.7d28a507.jpg";